import {getSupportedRegionCodes, parsePhoneNumber} from "awesome-phonenumber";

export function phone(regionCode, strict, errorMessage) {
    let availableRegions = getSupportedRegionCodes();

    const errMsg =
        typeof errorMessage === 'string' && errorMessage
            ? errorMessage
            : availableRegions.includes(regionCode)
                ? `\${path} must be a valid phone number for ${regionCode.toLowerCase()} region`
                : '${path} must be a valid phone number.';

    if (!regionCode) {
        regionCode = 'US';
    }

    return this.test('phone', errMsg, (value) => {
        if (!value && !strict) {
            return true;
        }

        try {
            const phoneNumber = parsePhoneNumber(value, {regionCode: regionCode});

            if (!phoneNumber.possible) {
                return false;
            }

            if (strict) {
                if (phoneNumber.regionCode !== regionCode.toUpperCase()) {
                    return false;
                }
                return phoneNumber.valid;
            }

            return true;
        } catch {
            return false;
        }
    })
}

export function ssn(strict, errorMessage) {
    const errMsg =
    typeof errorMessage === 'string' && errorMessage
        ? errorMessage
        : '${path} must be a valid Social Security Number';

    return this.test('ssn', errMsg, (value) => {
        if (!value && !strict) {
            return true;
        }

        if (!value) {
            return false;
        }

        // Remove all non-digit characters
        const cleanSSN = value.replace(/\D/g, '');

        // Must be exactly 9 digits
        if (cleanSSN.length !== 9) {
            return false;
        }

        // Basic SSN validation rules
        // Cannot be all zeros or have all zeros in any section
        if (cleanSSN === '000000000'
          || cleanSSN.substring(0, 3) === '000'
          || cleanSSN.substring(3, 5) === '00'
          || cleanSSN.substring(5, 9) === '0000') {
            return false;
        }

        // Cannot start with 9 (except for ITIN which starts with 9)
        // For strict SSN validation, you might want to exclude 9xx-xx-xxxx
        if (strict && cleanSSN.charAt(0) === '9') {
            return false;
        }

        return true;
    });
}